import { render, staticRenderFns } from "./configuraciones.vue?vue&type=template&id=b76728ca&scoped=true&"
import script from "./configuraciones.vue?vue&type=script&lang=js&"
export * from "./configuraciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76728ca",
  null
  
)

export default component.exports